import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import FacilitatorTemplateSingle from '../list/single/component';
import FacilitatorTemplateForm from './form/component';
FacilitatorTemplateDetails.propTypes = {
    templateID: PropTypes.string,
    onTitleChange: PropTypes.func,
    onDateTimeChange: PropTypes.func
};
export default function FacilitatorTemplateDetails(_a) {
    var _b = _a.templateID, templateID = _b === void 0 ? '' : _b, _c = _a.onTitleChange, onTitleChange = _c === void 0 ? null : _c, _d = _a.onDateTimeChange, onDateTimeChange = _d === void 0 ? null : _d;
    var gameTemplates = useSelector(function (state) { return state.general.gameTemplates; });
    var selectedTemplate = gameTemplates.find(function (x) { return x._id === templateID; });
    if (!selectedTemplate)
        return null;
    return (React.createElement("div", { className: "customtemplatearea" },
        React.createElement("div", { className: "customtemplatearea__card" },
            React.createElement(FacilitatorTemplateSingle, { id: selectedTemplate._id, name: selectedTemplate.name, description: selectedTemplate.description, selectedTemplateID: selectedTemplate._id, onTemplateClick: function () { } })),
        React.createElement("div", { className: "customtemplatearea__form" },
            React.createElement(FacilitatorTemplateForm, { onTitleChange: onTitleChange, onDateTimeChange: onDateTimeChange }))));
}
